/** Countdown clock-drift correction: call `setServerTimeOffset(serverTime)` when a WebSocket delivers serverTime, then use `getSynchronizedNow()` instead of `Date.now()` for countdown math, or devices show different values. `computeCountdown` is that math, and it lives HERE because it is the ONLY consumer of the offset this leaf holds and its one dependency `parseDate` is a `const/` leaf (`const/date-parse-format.ts`) -- a `utils/` leaf may not value-import a utils sibling, so a home of its own could not reach the offset. */

import { parseDate } from '@federa/const/date-parse-format';
import { TIME_UNITS } from '@federa/const/time-units';

let serverTimeOffset = 0;

/** Calculate and store the offset between server time and local time; call whenever a serverTime (epoch ms) arrives from the backend. */
export function setServerTimeOffset(serverTime: number): void {
	if (!serverTime || typeof serverTime !== 'number' || serverTime <= 0) {
		return;
	}

	const localNow = Date.now();
	serverTimeOffset = serverTime - localNow;
}

/** Current time synchronized with the server, falling back to local time when no server time has been set. */
export function getSynchronizedNow(): number {
	return Date.now() + serverTimeOffset;
}

/** Compute countdown in seconds from a target timestamp, using synchronized server time. Returns seconds remaining, 0 if expired, null if invalid. */
export function computeCountdown(targetUtc: string | null | undefined): number | null {
	if (!targetUtc) return null;
	const target = parseDate(targetUtc);
	if (!target) return null;
	const remaining = Math.floor((target.getTime() - getSynchronizedNow()) / TIME_UNITS.SECOND_MS);
	return remaining > 0 ? remaining : 0;
}
